import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@env';
import * as Sentry from '@sentry/angular';

if (environment.SENTRY_DSN != null) {
Sentry.init({
  dsn: environment.SENTRY_DSN,
  environment: environment.environmentName,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
});

}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
